"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const browser_settings_1 = require("../utils/browser_settings");
const delayed_1 = require("../utils/delayed");
const helpers_1 = require("../utils/helpers");
const action_1 = require("./action");
const dropdown_1 = require("./dropdown");
const form_for_1 = require("./form_for");
/**
 * wrap the column title element into a `a` link anchor, which allow to toggle
 *  the sort direction.
 */
function wrapColumnTitle(field, table, ...args) {
    if (!field.sortable)
        return (0, mithril_1.default)("span", ...args);
    let currentSortField = table.state.orderField;
    let currentSortDirection = table.state.orderDirection;
    let isSortingByField = field.name == currentSortField;
    const onclick = function (evt) {
        evt.preventDefault();
        if (isSortingByField) {
            //Toggle the direction
            currentSortDirection = currentSortDirection == "asc" ? "desc" : "asc";
        }
        else {
            currentSortDirection = "asc";
        }
        table.state.onorder(field.name, currentSortDirection);
    };
    let dirIcon = currentSortDirection == "asc" ? "up" : "down";
    return (0, mithril_1.default)("a", { onclick: onclick }, ...args, (isSortingByField ?
        (0, mithril_1.default)("span", { class: "icon is-small" }, (0, mithril_1.default)("i", { class: `fas fa-sort-${dirIcon}` })) :
        undefined));
}
/**
 * render the headers of each column
 */
function renderColumnHeaders(table) {
    let columns = table.options.fields.map((field) => {
        const renderer = field.headerRenderer || (() => { return field.label || field.name; });
        return (0, mithril_1.default)("th", wrapColumnTitle(field, table, renderer()));
    });
    if (table.options.actions)
        columns.push((0, mithril_1.default)("th")); // Add the action column
    return (0, mithril_1.default)("tr", columns);
}
function columnCount(table) {
    return table.options.fields.length + (table.options.actions ? 1 : 0);
}
function renderBody(table) {
    const collection = table.state.collection;
    if (!collection || collection.data.length == 0) {
        return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: columnCount(table) }, (0, mithril_1.default)("div", { class: "empty text-center" }, "Cette collection est vide")));
    }
    const rowRenderer = table.options.rowRenderer || ((_, fields) => { return (0, mithril_1.default)("tr", fields); });
    return collection.data.map((x) => {
        const fields = table.options.fields.map((field) => {
            const renderer = field.renderer || ((x) => { return (0, mithril_1.default)("div", x[field.name]); });
            return (0, mithril_1.default)("td", renderer(x, x[field.name]));
        });
        let actions = table.options.actions;
        if (actions)
            fields.push((0, mithril_1.default)("td", actions(x)));
        return rowRenderer(x, fields);
    });
}
function renderSearch(table) {
    return (0, mithril_1.default)("p", { class: "control has-icons-left" }, (0, mithril_1.default)("input", {
        type: "text",
        class: "input",
        value: table.state.search,
        oncreate: (vnode) => {
            vnode.dom.focus();
        },
        oninput: (e) => { table.state.onsearch(e.target.value); }
    }), (0, mithril_1.default)("span", { class: "icon is-small is-left" }, (0, mithril_1.default)("i", { class: "fas fa-search" })));
}
function hasFilters(table) {
    return (Object.keys(table.options.filters).length > 0);
}
function renderFilters(table, vnode) {
    const cbPrint = (x, active) => {
        if (active) {
            return (0, mithril_1.default)("div", (0, helpers_1.iconSpan)("fa-check"), x);
        }
        else {
            return (0, mithril_1.default)("div", (0, helpers_1.iconSpan)("fa-none"), x);
        }
    };
    if (Object.keys(table.options.filters).length > 0) {
        let filters = [
            dropdown_1.Dropdown.linkItem(cbPrint("Aucun filtres", table.state.filters.length == 0), () => { table.state.onfilters([]); }),
            dropdown_1.Dropdown.divider()
        ];
        const selectedFilters = table.state.filters;
        for (let key in table.options.filters) {
            ((key) => {
                const idx = selectedFilters.indexOf(key);
                const isActive = idx != -1;
                filters.push(dropdown_1.Dropdown.linkItem(cbPrint(table.options.filters[key], isActive), () => {
                    table.state.currentPage = 1;
                    if (table.options.filterMode == "exclusive") {
                        table.state.onfilters([key]);
                    }
                    else {
                        if (isActive) {
                            // Deactivate this filter if active
                            selectedFilters.splice(idx, 1); //If found we remove the filter
                        }
                        else {
                            selectedFilters.push(key);
                        }
                        table.state.onfilters(selectedFilters);
                    }
                }));
            })(key);
        }
        return (0, mithril_1.default)("div", (0, mithril_1.default)(dropdown_1.Dropdown, {
            onclick: () => { vnode.state.toggleFilter = !vnode.state.toggleFilter; },
            onblur: () => {
                vnode.state.toggleFilter = false;
            },
            text: [(0, helpers_1.iconSpan)("fa-filter")],
            active: vnode.state.toggleFilter
        }, filters));
    }
    return undefined;
}
function renderTopBar(table, vnode) {
    const topMenuRenderRight = table.options.topMenuRight || (() => { return undefined; });
    const topMenuRenderLeft = table.options.topMenuLeft || (() => { return undefined; });
    let title = table.options.title;
    if (typeof (title) === "string")
        title = (0, mithril_1.default)(".content", (0, mithril_1.default)("h2", table.options.title));
    let tools;
    if (hasFilters(table)) {
        tools = (0, mithril_1.default)(".field.has-addons", (0, mithril_1.default)(".control", renderFilters(table, vnode)), (0, mithril_1.default)(".control", renderSearch(table)));
    }
    else {
        tools = renderSearch(table);
    }
    return (0, helpers_1.level)({
        left: [
            title,
            topMenuRenderLeft(),
        ],
        right: [
            tools,
            topMenuRenderRight(),
        ]
    });
    // m("div", {class: "is-pulled-right"}, columns(
    //   renderSearch(table),
    //   renderFilters(table, vnode),
    //   topMenuRender()
    // ))
}
function renderPages(table) {
    const pagination = table.state.collection.pagination;
    let out = [];
    if (pagination.pageCount > 1) {
        if (pagination.currentPage != 1) {
            out.push((0, action_1.action)([(0, helpers_1.iconSpan)("fa-chevron-left"), "Precedent"], () => { table.state.onpagechange(pagination.currentPage - 1); }));
        }
        else {
            out.push((0, mithril_1.default)("div"));
        }
        out.push((0, mithril_1.default)("div", { style: "text-align: center" }, `Page ${pagination.currentPage} / ${pagination.pageCount}`));
        if (pagination.currentPage != pagination.pageCount) {
            out.push((0, mithril_1.default)("div", { class: "has-text-right" }, (0, action_1.action)(["Suivant", (0, helpers_1.iconSpan)("fa-chevron-right")], () => { table.state.onpagechange(pagination.currentPage + 1); })));
        }
        else {
            out.push((0, mithril_1.default)("div"));
        }
    }
    else {
        out.push((0, mithril_1.default)("div"));
        out.push((0, mithril_1.default)("div", { style: "text-align: center" }, `Total ${table.state.collection.data.length} objets`));
        out.push((0, mithril_1.default)("div"));
    }
    return (0, form_for_1.columns)(...out);
}
function changePageCount(table, count) {
    const key = `table.${table.options.id}.itemsPerPage`;
    table.state.onpagecountchange(browser_settings_1.BrowserSettings.set(key, count));
    table.state.currentPage = 1;
}
function renderNbItems(table) {
    return (0, mithril_1.default)("span", "Afficher ", (0, action_1.action)("15", () => { changePageCount(table, 15); }), " | ", (0, action_1.action)("50", () => { changePageCount(table, 50); }), " | ", (0, action_1.action)("100", () => { changePageCount(table, 100); }), " lignes par page");
}
function renderFooter(table) {
    return (0, mithril_1.default)(".table-footer", renderPages(table), renderNbItems(table));
}
function createTable(options) {
    const fetch = (page) => {
        let opts = {
            sortBy: dsl.state.orderField,
            sortDirection: dsl.state.orderDirection,
            page: page || dsl.state.currentPage,
            search: dsl.state.search,
            count: dsl.state.itemsPerPage
        };
        let filters = dsl.state.filters;
        if (filters && filters.length > 0) {
            opts.scopes = filters.join(",");
        }
        for (let k in opts) {
            if (opts[k] === undefined || opts[k] === null) {
                delete opts[k];
            }
        }
        let promise;
        if (dsl.options.ajax) {
            promise = dsl.options.ajax(opts, dsl.options.provider);
        }
        else {
            promise = options.provider.index(opts);
        }
        promise.then((collection) => {
            dsl.state.collection = collection;
        });
    };
    let dsl = {
        state: {
            collection: {
                data: [],
                pagination: {
                    currentPage: 1,
                    itemCount: 1,
                    itemPerPage: 1,
                    pageCount: 1
                },
                status: 'fetching'
            },
            itemsPerPage: browser_settings_1.BrowserSettings.get(`table.${options.id}.itemsPerPage`, 15),
            currentPage: 1,
            filters: [],
            onfilters: (filters) => {
                dsl.state.filters = filters;
                fetch();
            },
            onorder: (orderField, orderDirection) => {
                dsl.state.orderDirection = orderDirection;
                dsl.state.orderField = orderField;
                fetch();
            },
            onpagechange: (page) => {
                dsl.state.currentPage = page;
                fetch();
            },
            onsearch: (searchTerm) => {
                dsl.state.search = searchTerm;
                (0, delayed_1.delayed)(options.id, () => fetch(1));
            },
            onpagecountchange: (pagecount) => {
                dsl.state.itemsPerPage = pagecount;
                fetch();
            }
        },
        options: options
    };
    return {
        state: dsl.state,
        fetch() { fetch(); },
        oncreate() {
            this.fetch();
        },
        view(vnode) {
            let hasOverlay = options.provider.isAjaxing() ? "has-overlay" : "";
            return (0, mithril_1.default)("div", { class: "for-table", key: options.id, id: options.id }, (0, mithril_1.default)("div", renderTopBar(dsl, vnode)), (0, mithril_1.default)("div", (0, mithril_1.default)(".table-container", (0, mithril_1.default)("table", { class: "is-hoverable is-fullwidth is-striped table" }, (0, mithril_1.default)("thead", renderColumnHeaders(dsl)), (0, mithril_1.default)("tbody", { class: hasOverlay }, renderBody(dsl)))), renderFooter(dsl)));
        }
    };
}
exports.createTable = createTable;
